import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function SocialPreview() {
  return <div style={{
    width: 1200,
    height: 630,
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'Inter', sans-serif"
  }} className="bg-charcoal-950" data-id="element-237" data-mp="36stl3j7as6ln">
      {/* Background image — action shot */}
      <img src="https://cdn.magicpatterns.com/uploads/nBbWR557z149baLXUu2DRm/94-IMG_5381.jpg" alt="" style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      objectPosition: 'center',
      filter: 'brightness(0.45)'
    }} data-id="element-238" data-mp="3gkzdgu1goq1d" />

      {/* Dark gradient overlay for text legibility */}
      <div style={{
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, rgba(10,10,10,0.92) 0%, rgba(10,10,10,0.6) 50%, rgba(10,10,10,0.85) 100%)'
    }} data-id="element-239" data-mp="3a09hby2xru4" />

      {/* Amber accent bar on left */}
      <div style={{
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: 12,
      background: '#d4a853'
    }} data-id="element-240" data-mp="f61arbfaozgz" />

      {/* Content */}
      <div style={{
      position: 'relative',
      zIndex: 10,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '0 80px',
      color: '#f5f5f0'
    }} data-id="element-241" data-mp="5cu5rrogvlhf">
        {/* Eyebrow */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        marginBottom: 24
      }} data-id="element-242" data-mp="t2omwlftjw7h">
          <div style={{
          width: 40,
          height: 4,
          background: '#d4a853',
          borderRadius: 2
        }} data-id="element-243" data-mp="k39tbd4cv5ir" />
          <span style={{
          fontSize: 18,
          fontWeight: 600,
          letterSpacing: '0.2em',
          textTransform: 'uppercase',
          color: '#d4a853'
        }} data-id="element-244" data-mp="34szcg2c3ddh9">
            McLean Physical Therapy
          </span>
        </div>

        {/* Main headline */}
        <h1 style={{
        fontSize: 88,
        fontWeight: 800,
        lineHeight: 1.05,
        letterSpacing: '-0.02em',
        margin: 0,
        marginBottom: 28,
        maxWidth: 900
      }} data-id="element-245" data-mp="2wf4cc8b74tnm">
          Where Recovery Meets{' '}
          <span style={{
          color: '#d4a853'
        }} data-id="element-246" data-mp="2scr7rn86r1sf">
            Performance
          </span>
        </h1>

        {/* Subtitle */}
        <p style={{
        fontSize: 26,
        lineHeight: 1.4,
        color: '#e8e8e0',
        margin: 0,
        marginBottom: 40,
        maxWidth: 820,
        fontWeight: 400
      }} data-id="element-247" data-mp="2imeodyc3xenv">
          Modern physical therapy and performance coaching — combining in-person
          care with personalized programming.
        </p>

        {/* Footer row */}
        <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        color: '#d4a853',
        fontSize: 22,
        fontWeight: 600
      }} data-id="element-248" data-mp="1l1mz3fhhh0im">
          <MapPinIcon size={24} data-id="element-249" data-mp="1u335zd93aki3" />
          <span data-id="element-250" data-mp="28xhkp1lmf7qy">Camarillo, CA · Serving Ventura County</span>
        </div>
      </div>
    </div>;
}